var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaseAtom1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 348,
    viewBox: "0 0 373 348",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M290.064 176.694C290.435 177.433 290.061 178.5 289.125 179.186C288.183 179.83 287.097 179.48 286.726 178.741L273.421 155.183C272.778 154.241 273.127 153.155 273.867 152.784C274.809 152.14 275.895 152.49 276.562 153.45L290.064 176.694ZM149.768 97.3494C149.397 96.6103 149.474 95.3215 150.213 94.95C151.155 94.3068 152.463 94.3597 152.834 95.0988L176.787 127.533C177.158 128.272 177.081 129.561 176.12 130.229C175.381 130.6 174.092 130.523 173.721 129.784L149.768 97.3494ZM193.399 170.415C193.249 169.379 193.623 168.312 194.633 168.143C195.89 167.697 196.755 168.342 196.905 169.378L205.86 200.615C206.01 201.651 205.636 202.719 204.625 202.887C203.589 203.037 202.522 202.663 202.353 201.652L193.399 170.415Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 157.244C137.631 157.394 136.766 156.748 136.616 155.712C136.466 154.677 137.112 153.812 138.148 153.662L165.583 149.18C166.619 149.03 167.484 149.675 167.634 150.711C167.784 151.746 167.138 152.611 166.102 152.761L138.667 157.244Z",
    fill: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.77 144.579C210.734 144.729 209.87 144.083 209.72 143.047C209.57 142.012 210.437 140.851 211.454 140.726L245.311 137.383C246.347 137.233 246.99 138.175 247.14 139.21C247.29 140.246 246.348 140.889 245.312 141.039L211.77 144.579Z",
    fill: "#263238"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133.498,
    cy: 70.7417,
    r: 30.5665,
    transform: "rotate(-143.246 133.498 70.7417)",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 208.187,
    cy: 217.696,
    r: 17.972,
    transform: "rotate(-143.246 208.187 217.696)",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 264.45,
    cy: 138.152,
    r: 17.972,
    transform: "rotate(-143.246 264.45 138.152)",
    fill: "#FFDB80",
    stroke: "#263238"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 188.312,
    cy: 146.786,
    r: 24.2692,
    transform: "rotate(-143.246 188.312 146.786)",
    fill: "#B4DFFC",
    stroke: "#263238"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 126.617,
    cy: 155.728,
    r: 12.0945,
    transform: "rotate(-143.246 126.617 155.728)",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.351,
    cy: 188.555,
    r: 13.354,
    transform: "rotate(-143.246 293.351 188.555)",
    fill: "#80FFAF",
    stroke: "#263238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseAtom1);
export default __webpack_public_path__ + "static/media/case-atom-1.d89a68c4fe7eb38bf41c4977b5f2c83f.svg";
export { ForwardRef as ReactComponent };